import React from 'react';

import Unauthenticated from 'Components/Layouts/Unauthenticated';
import AuthLayout from 'Components/Layouts/AuthLayout';
import {FormHandler, Input, Select} from 'Components/Form';

import Auth from 'Services/Api/Auth/Auth';

import {translation} from 'Services/TranslationHelpers';

class Register extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = 'Your account has been successfully created.';

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {form, handleInput, getFieldError, handleSubmit, working, alert} = this.props;

        return (
            <Unauthenticated>
                <AuthLayout
                    // title="Lite Login"
                    backLink="/login"
                    backLinkText="Already have an account?"
                    submitText="Submit"
                    onSubmit={(e) => handleSubmit(e, Auth.liteRegister, this.success, true)}
                    working={working}
                    alert={alert}
                >
                    <div className="grid grid-cols-1 gap-4 mb-4">
                        <Input
                            label="First Name"
                            type="text"
                            value={form.first_name}
                            error={getFieldError('first_name')}
                            onChange={v => handleInput('first_name', v)}
                        />

                        <Input
                            label="Last Name"
                            type="text"
                            value={form.last_name}
                            error={getFieldError('last_name')}
                            onChange={v => handleInput('last_name', v)}
                        />

                        <Input
                            label="Store Number / Support Office"
                            type="text"
                            value={form.store_number}
                            error={getFieldError('store_number')}
                            onChange={v => handleInput('store_number', v)}
                        />

                        <Select
                            label="Region - If you are a support office please select the region you are viewing from"
                            value={form.region}
                            id="region"
                            error={getFieldError('region')}
                            onChange={(v) => handleInput('region', v)}
                            options={window.base.lite_regions.map((region) => ({
                                value: region,
                                label: region
                            }))}
                        />

                        <Input
                            type="password"
                            label={translation('auth_frontend', 'password')}
                            value={form.password}
                            onChange={v => handleInput('password', v)}
                        />
                    </div>
                </AuthLayout>
            </Unauthenticated>
        );
    }
}

export default FormHandler(Register);
